import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';


const SkeletonLoader = ({ isLoading, skeletonProps, children }) => {
    if (isLoading) {
        return <Skeleton {...skeletonProps} data-testid="skeleton-loader" />;
    }
    return children;
};

SkeletonLoader.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    skeletonProps: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired
};

export default SkeletonLoader;
